import React, { useState }  from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../api/AuthProvider';
import LoginModal from './LoginModal';
import Hamburger from "./Hamburger";
import nectrLogo from '../../static/images/Pink logo - no background - just logo.png';

export default function Navbar() {
    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const [isOpen, setIsOpen] = useState(false);
    const [showLogin, setShowLogin] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    async function handleLogout() {
        try {
            await logout();  // clear session + cookies
        } catch (err) {
            console.error("Logout failed", err);
        }
    }

    return (
        <nav className="navbar navbar-expand-lg nav-nectr py-3 px-3 px-lg-4">
            <div className="container-fluid nav-container">
                <img src={nectrLogo} alt="Nectr Design" className="header-logo" />
                <a className="navbar-brand fw-semibold" href="/">Nectr Studio</a>
                <Hamburger open={isOpen} onToggle={toggleMenu} aria-controls="mainNav"/>

                <div className={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="mainNav">
                    <ul className="navbar-nav ms-auto align-items-lg-center gap-lg-3">
                        <li className="nav-item">
                            <a className="nav-link nav-ink" href="/solutions">Solutions</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link nav-ink" href="/pricing">Pricing</a>
                        </li>
                        {/*<li className="nav-item">*/}
                        {/*    <a className="nav-link nav-ink" href="/our-work">Our Work</a>*/}
                        {/*</li>*/}
                    </ul>

                    <div className="d-flex align-items-start ms-lg-3 gap-2 flex-column flex-lg-row">
                        <a href="/get-started" className="btn btn-get-started btn-pill">Get started</a>
                        {/*<a href="/login" className="login-link d-flex d-lg-inline">Login</a>*/}
                        <div className="ms-auto">
                            {!user ? (
                                <button className="btn login-link d-flex d-lg-inline" onClick={() => setShowLogin(true)}>Log in</button>
                            ) : (
                                <>
                                    <button className="btn login-link d-flex d-lg-inline me-2" onClick={() => navigate('/account')}>Profile</button>
                                    <button className="btn btn-outline-danger" onClick={handleLogout}>Log out</button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <LoginModal
                show={showLogin}
                onHide={() => setShowLogin(false)}
                onSuccess={() => navigate('/account')}
            />
        </nav>
    );
}
